import { useCallback } from 'react';
import { useEvent } from 'effector-react';
import { setLastPublishTimeEvent } from '@nx-frontend/shared/store/change-events-store';
import { openFileSelect } from '../files-upload';
import { UploadContext } from '../model';
import { useFilesUpload } from './useFilesUpload';

export const useStartFilesUpload = (): ((context: UploadContext, accept?: string) => void) => {
  const [setLastPublishTime] = useEvent([setLastPublishTimeEvent]);

  const filesUpload = useFilesUpload({
    onSuccess: () => {
      const time = new Date().getTime();
      setLastPublishTime(time);
    },
  });

  return useCallback(
    (context: UploadContext, accept?: string) => {
      openFileSelect({
        onSelect: (files: FileList | null) => {
          if (files) {
            const filesArr = Array.from(files);
            filesUpload({
              files: filesArr,
              context,
            });
          }
        },
        accept,
      });
    },
    [filesUpload]
  );
};
